import { CopyBtn } from './CopyBtn'

export default CopyBtn
